import * as segmentClient from '@/src/services/segment'
import { useEffect } from 'react'
import { useSardine } from '@/src/services/Sardine'
import { usePathname } from 'expo-router'
import { normalizeRoute } from '@/src/common/utils/normalizeRoute'

export function useTrackPage() {
  const pathname = usePathname()

  const { trackPage } = useSardine()
  useEffect(
    function trackPageInSardine() {
      void trackPage(pathname)
    },
    [trackPage, pathname],
  )

  useEffect(
    function trackPageInSegment() {
      try {
        const { normalizedPath, parameters } = normalizeRoute(pathname)
        void segmentClient.screen(normalizedPath, parameters)
      } catch (_) {
        // Fall back to original pathname if normalization fails
        void segmentClient.screen(pathname)
      }
    },
    [pathname],
  )
}
